import { defineMessages } from 'react-intl'

export default defineMessages({
    label: {
        defaultMessage: 'Teléfono móvil',
    },
    placeholder: {
        defaultMessage: 'Ej.: 000 000 000',
    },
    requiredError: {
        defaultMessage: 'Obligatorio',
    },
    phoneError: {
        defaultMessage: 'No es un teléfono válido',
    },
    lengthError: {
        defaultMessage: 'Debe tener entre 9 y 20 caracteres',
    },
    number: {
        defaultMessage: 'Solamente debe contener números',
    },
})
